import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { getSession } from '../utils/utils';

function FormularioDefinicionServicio() {

	const navigate = useNavigate();
	const [origin, setOrigin] = useState(null);
	const [userInfo, setUserInfo] = useState({
		role: null
	});

	async function getInfo() {
		let session = await getSession();
		
		if (session !== null) {
			setUserInfo(session);
			return;
		}

		// navigate("/");

		return;
	}

	useEffect(
		function () {
			getInfo();
		}
		, []
	)

	const { register, handleSubmit, formState: { errors } } = useForm({
		initialValues: {
			preg1: "",
			preg2: "",
			preg3: "",
			preg4: ""
		}
	})

	let totalErrors = Object.values(errors).length;

	async function sendData(e) {
		// console.log(e);
		// console.log(origin);
		let form = JSON.parse(sessionStorage.getItem("Empleado-Info"))
		form.conocimiento_beneficio = e
		// console.log(form)
		sessionStorage.setItem("Empleado-Info", JSON.stringify(form))

		let uri = process.env.REACT_APP_API_URL + 'formularios';

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				'Accept': 'application/json'
			}
		};

		try {
			let response = await axios({
				method: 'POST',
				url: uri,
				data: form,
				headers: config.headers
			});
			// console.log(response);
			Swal.fire({
				title: 'Registro exitoso',
				text: 'Datos enviados correctamente',
				icon: 'success',
				confirmButtonText: 'Aceptar'
			})
			.then(function () {
				localStorage.removeItem("FormDatosTrabajador");
				localStorage.removeItem("FormHijos");
				localStorage.removeItem("FormServicio");

				if (userInfo?.role) {
					navigate("/Inicio")
				} else {
					navigate("/")
				}
			})
		} catch (error) {
			console.log(error);
			Swal.fire({
				title: "Error",
				text: "Error al subir los datos, intenta nuevamente",
				icon: "error"
			});
		}



		// try {
		// } catch (error) {
		//   console.log(error);
		//   Swal.fire({
		//     title: "Error",
		//     text: "Completa todos los campos para continuar",
		//     icon: "error"
		//   });
		// }
	}

	return (
		<div className="mt-6 w-auto mr-6">
			<div className="ml-5">
				<h1 className="text-3xl font-bold text-custom-main">
					Medición del interés de uso del beneficio CAPI 
				</h1>
				<p className='text-sm md:text-base mb-2'>
					En esta sección debes indicar tu interés por la utilización del beneficio CAPI, la información que proporciones es fundamental para mejorar la experiencia que te puede ofrecer tu empleador en el uso del beneficio. Completa todos los campos con información precisa y actual.
				</p>
			</div>
			<form className="flex flex-col ml-5 w-auto text-lg" onSubmit={handleSubmit(sendData)}>
				<p className="text-base font-semibold italic mt-2 mb-4">
					"Un Centro de Atención a la Primera Infancia (CAPI) es un establecimiento que brinda atención integral a niños desde los primeros meses de edad hasta los cuatro años, promoviendo cuidado cariñoso, estimulación temprana y educación de calidad"
				</p>
				<div className={`flex flex-col justify-between w-auto p-4 border-2 rounded-lg mb-2 bg-[#D1ECF2] ${errors.preg1 ? 'border-red-600' : ''}`}>
					<div className='flex flex-row justify-between'>
						<label htmlFor='preg1' className='font-semibold'>¿Estás interesado en usar el beneficio CAPI que ofrecerá tu empresa?</label>
						<div className="flex justify-between w-[100px]">
							<label>
								<input type="radio" value="Si" {...register("preg1", { required: "Elige una respuesta" })} />Si
							</label>
							<label>
								<input type="radio" value="No" {...register("preg1", { required: "Elige una respuesta" })} />
								No
							</label>
						</div>
					</div>
				</div>
				{errors.preg1 && <span className='text-red-600 font-bold w-full px-2 flex justify-end'>{errors.preg1.message}</span>}
				<div className="mr-2 w-full flex flex-row justify-between items-center p-2 border rounded-lg mb-2 bg-[#D1ECF2]">
					<label htmlFor='preg2' className="p-1 w-3/4 font-semibold">Si te ofrecen el beneficio CAPI, donde preferirías utilizar el beneficio: (opcional)</label>
					<select className="w-1/4 border-2 p-4 h-2/3 text-lg font-normal bg-white rounded-lg" {...register("preg2")}>
						<option value="">Donde prefieres utilizarlo</option>
						<option value="Cerca de Residencia">Cerca de la residencia de tu hijo</option>
						<option value="Cerca de Trabajo">Cerca de tu centro de trabajo</option>
						<option value="Cerca de Lugar de Cuido">Cerca del lugar de cuido de tu hijo</option>
					</select>
				</div>
				<div htmlFor="preg3" className={`mr-2 w-full flex flex-row justify-between items-center p-2 border-2 rounded-lg mb-2 bg-[#D1ECF2] ${errors.preg3 ? 'border-red-600' : ''}`}>
					<label className="p-1 w-3/4 font-semibold">De utilizar el beneficio de Centro de Atención a la Primera infancia (CAPI), ¿Quién llevaría a tu hijo(a) a las instalaciones de éste?</label>
					<select className={`w-1/4 border-2 p-4 h-2/3 text-lg font-normal bg-white rounded-lg ${errors.preg3 ? 'border-red-600' : ''}`} {...register("preg3", { required: "Elige una respuesta" })}>
						<option value="">¿Quíen lo llevaría?</option>
						<option value="yo">Yo</option>
						<option value="madre">Madre</option>
						<option value="padre">Padre</option>
						<option value="conyugue">Cónyuge</option>
						<option value="abuelos">Abuelos</option>
						<option value="otro">Otro familiar</option>
					</select>
				</div>
				{errors.preg3 && <span className='text-red-600 font-bold w-full px-2 flex justify-end'>{errors.preg3.message}</span>}
				<div className={`mr-2 w-full flex flex-row justify-between items-center p-2 border-2 rounded-lg mb-2 bg-[#D1ECF2] ${errors.preg4 ? 'border-red-600' : ''}`}>
					<label htmlFor='preg4' className="p-1 w-3/4 font-semibold">De utilizar en la actualidad una guardería, ¿Cuál es el nombre de la guardería / kínder / establecimiento?  </label>
					<input id="" placeholder="Nombre del establecimiento" className="w-1/4 border-2 p-4 text-lg h-2/3 bg-white rounded-lg font-normal" type="text" {...register("preg4", { required: "Ingresa el nombre del establecimiento" })} />
				</div>
				{errors.preg4 && <span className='text-red-600 font-bold w-full px-2 flex justify-end'>{errors.preg4.message}</span>}
				<div className="flex justify-end mt-2">
					<div className='w-[180px] justify-between flex flex-row'>
						<Link to="/DatosHijos" data-discover="true">
							<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
						</Link>
						<button className="bg-[#99C33E] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[120px] h-[50px] p-[12px]" type='submit'>Enviar</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default FormularioDefinicionServicio;